const decodeHtmlEntities = (value) => String(value || '')
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCodePoint(parseInt(hex, 16)))
    .replace(/&#([0-9]+);/g, (_, decimal) => String.fromCodePoint(parseInt(decimal, 10)))
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&apos;|&#39;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>');

export const articleTextFromHtml = (html) => decodeHtmlEntities(html)
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const normalizeGeneratedText = (value) => decodeHtmlEntities(value)
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201c\u201d]/g, '"')
    .replace(/\u2014/g, ' - ')
    .replace(/\s+/g, ' ')
    .trim();

export const hasCompleteMetaDescription = (value) => {
    const description = String(value || '').trim();
    return Boolean(description) && description.length <= 160 && !description.endsWith('...');
};

export const generateMetaDescription = (articleText) => {
    const text = normalizeGeneratedText(articleText);
    const sentences = text.match(/[^.!?]*[.!?](?:["'])?(?=\s|$)/g) || [];
    let prefix = '';

    for (const rawSentence of sentences) {
        const sentence = rawSentence.trim();
        const candidate = `${prefix} ${sentence}`.trim();
        if (candidate.length > 155) break;
        prefix = candidate;
    }

    if (prefix) return prefix;

    return sentences
        .map((sentence) => sentence.trim())
        .find((sentence) => sentence.length > 0 && sentence.length <= 155) || '';
};

export const resolveMetaDescription = (configuredDescription, articleHtml = '') => {
    if (hasCompleteMetaDescription(configuredDescription)) {
        return String(configuredDescription).trim();
    }

    return generateMetaDescription(articleTextFromHtml(articleHtml));
};
